/**
 * @file aiValidation.js
 * @description Pure rule-based validation for invoice form data.
 *
 * Takes the formData and returns an array of validation results.
 * No React, no state, no side effects.
 *
 * @param {object} formData - The full invoice form state
 * @returns {Array<{ type, field, message, suggestion }>}
 */
export const runAIValidation = (formData) => {
  const results = [];

  if (formData.customer.type === "company" && !formData.customer.vatNumber) {
    results.push({
      type: "error",
      field: "customer.vatNumber",
      message: "VAT number is required for B2B transactions",
      suggestion: "Please add the customer's VAT registration number",
    });
  }

  if (formData.totals.total > 100000) {
    results.push({
      type: "warning",
      field: "totals.total",
      message: "High invoice amount detected",
      suggestion: "Consider splitting large transactions or verify amounts",
    });
  }

  if (formData.invoice.type === "simplified" && formData.totals.total > 1000) {
    results.push({
      type: "error",
      field: "invoice.type",
      message: "Simplified invoices are limited to SAR 1,000",
      suggestion: "Use standard invoice type for amounts above SAR 1,000",
    });
  }

  return results;
};